
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';
import {
  Steps, Form, Input, Select, Row, Col, Button, TimePicker, Spin,
} from 'ant-design-vue';
import { MinusCircleOutlined, DownOutlined } from '@ant-design/icons-vue';
import UploadImg from '@/components/UploadImg.vue';
import asynButtonVue from '@/components/asynButton.vue';
import {
  UnitExperiment, UnitExperimentController, UnitTimeModes, EndConditionType,
} from './js/unitExperiment';
import { BasicInfo, caseUnits } from '../basicinfo/basicInfo';

export default defineComponent({
  name: 'UnitExperiment',
  components: {
    aForm: Form,
    aFormItem: Form.Item,
    aInput: Input,
    aTextarea: Input.TextArea,
    aSteps: Steps,
    aStep: Steps.Step,
    aSelect: Select,
    aSelectOption: Select.Option,
    aButton: asynButtonVue,
    aTimePicker: TimePicker,
    MinusCircleOutlined,
    DownOutlined,
    Row,
    Col,
    aSpin: Spin,
    UploadImg,
  },
  data() {
    return {
      labelCol: {
        span: 5,
      },
      wrapperCol: {
        span: 19,
      },
    };
  },
  setup(props, { emit }) {
    const router = useRouter();
    const basicInfo = new BasicInfo(router.currentRoute.value.params.caseId as string);
    const unitExperiment = new UnitExperiment(router.currentRoute.value.params.caseId as string, basicInfo.selectedUnits);
    const unitExperimentController = new UnitExperimentController(unitExperiment, emit);
    // CustomCase.unitExperiment =
    return {
      basicInfo,
      caseUnits,
      unitExperiment,
      unitExperimentController,
      UnitTimeModes,
      EndConditionType,
    };
  },
});
